import { Selector, State, StateContext } from '@ngxs/store';
import { Receiver, EmitterAction } from '@ngxs-labs/emitter';
import { Injectable } from '@angular/core';

export interface AppStateModel {
  userId?: string;
  tenantId?: number;
  contactId?: string;
  token?: string;
  refreshToken?: string;
  tenantName?: string;
  email?: string;
  ssoOtp?: string;
  loginType?: string;
}

@State<AppStateModel>({
  name: 'nxMobileApp',
  defaults: {}
})
@Injectable()
export class AppState {

  @Selector()
  static token(state: AppStateModel): string {
    return state.token || '';
  }

  @Selector()
  static tenantId(state: AppStateModel): number {
    return state.tenantId;
  }

  @Selector()
  static userId(state: AppStateModel): string {
    return state.userId || '';
  }

  @Selector()
  static contactId(state: AppStateModel): string {
    return state.contactId || '';
  }


  @Selector()
  static isAuthenticated(state: AppStateModel): boolean {
    return !!state.token;
  }

  @Selector()
  static refreshToken(state: AppStateModel): string {
    return state.refreshToken || '';
  }

  @Selector()
  static tenantName(state: AppStateModel): string {
    return state.tenantName || '';
  }
  @Selector()
  static email(state: AppStateModel): string {
    return state.email || '';
  }
  @Selector()
  static ssoOtp(state: AppStateModel): string {
    return state.ssoOtp || '';
  }
  @Selector()
  static loginType(state: AppStateModel): string {
    return state.loginType || '';
  }


  @Receiver()
  static setAuthDetails(
    { setState, getState }: StateContext<AppStateModel>,
    { payload }: EmitterAction<AppStateModel>) {
    const newState = { ...getState(), ...payload };
    setState(newState);
  }

  @Receiver()
  static setTenantId(
    { patchState }: StateContext<AppStateModel>,
    { payload }: EmitterAction<number>) {
    patchState({ tenantId: payload });
  }

}
